import { Injectable } from '@angular/core';
import { Observable, takeUntil, timer } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TimerService {
  constructor() { }

  startTimer(limit: number, initialDelay: number = 0, interval: number = 1000): Observable<number> {
    const stopTimer$ = timer(limit);
    return timer(initialDelay, interval).pipe(takeUntil(stopTimer$));
  }
}
